var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#A2FDC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6248 10.1667C16.6248 9.82157 16.345 9.54175 15.9998 9.54175C15.6547 9.54175 15.3748 9.82157 15.3748 10.1667L15.3748 15.3751H10.1665C9.82133 15.3751 9.5415 15.6549 9.5415 16.0001C9.5415 16.3453 9.82133 16.6251 10.1665 16.6251H15.3748V21.8334C15.3748 22.1786 15.6547 22.4584 15.9998 22.4584C16.345 22.4584 16.6248 22.1786 16.6248 21.8334L16.6248 16.6251H21.8332C22.1783 16.6251 22.4582 16.3453 22.4582 16.0001C22.4582 15.6549 22.1783 15.3751 21.8332 15.3751H16.6248V10.1667Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.369fc144f8c9ccea1de56efc2189e441.svg";
export { ForwardRef as ReactComponent };